"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const jsx_dev_runtime_1 = __importDefault(require("react/jsx-dev-runtime"));
const jsx_runtime_1 = __importDefault(require("react/jsx-runtime"));
const remotion_1 = require("remotion");
const originalCreateElement = react_1.default.createElement;
const originalJsx = jsx_runtime_1.default.jsx;
const originalJsxs = jsx_runtime_1.default.jsxs;
const originalJsxDev = jsx_dev_runtime_1.default.jsxDEV;
const getSourceFileName = (fileName) => {
    if (typeof window === 'undefined' || !window.remotion_cwd) {
        return fileName;
    }
    const normalizedFileName = fileName.replaceAll('\\', '/');
    const normalizedRoot = window.remotion_cwd
        .replaceAll('\\', '/')
        .replace(/\/+$/, '');
    const shouldCompareCaseInsensitive = /^[a-z]:\//i.test(normalizedFileName) || /^[a-z]:\//i.test(normalizedRoot);
    const comparableFileName = shouldCompareCaseInsensitive
        ? normalizedFileName.toLowerCase()
        : normalizedFileName;
    const comparableRoot = shouldCompareCaseInsensitive
        ? normalizedRoot.toLowerCase()
        : normalizedRoot;
    if (!comparableFileName.startsWith(`${comparableRoot}/`)) {
        return normalizedFileName;
    }
    return `./${normalizedFileName.slice(normalizedRoot.length + 1)}`;
};
let stackTracesEnabled = false;
const enableSequenceStackTraces = () => {
    if (stackTracesEnabled) {
        return;
    }
    stackTracesEnabled = true;
    react_1.default.createElement = remotion_1.Internals.createElementSourceProxy(originalCreateElement, null, getSourceFileName);
    jsx_runtime_1.default.jsx = remotion_1.Internals.createElementSourceProxy(originalJsx, null, getSourceFileName);
    jsx_runtime_1.default.jsxs = remotion_1.Internals.createElementSourceProxy(originalJsxs, null, getSourceFileName);
    if (originalJsxDev) {
        jsx_dev_runtime_1.default.jsxDEV = remotion_1.Internals.createElementSourceProxy(originalJsxDev, 4, getSourceFileName);
    }
};
if (typeof window !== 'undefined') {
    window.remotion_enableSequenceStackTraces = enableSequenceStackTraces;
}
if (process.env.NODE_ENV !== 'production') {
    const RefreshRuntime = require('react-refresh/runtime');
    remotion_1.Internals.setComponentIdentityResolver((component) => {
        var _a;
        return (_a = RefreshRuntime.getFamilyByType(component)) !== null && _a !== void 0 ? _a : component;
    });
    enableSequenceStackTraces();
}
